import { List } from "immutable";
import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";

interface IState {
    allCollectionsFetched: boolean;
    error?: boolean;
    isCreating?: boolean;
    isCopying?: boolean;
    isFetching: boolean;
    results: List<any>;
}

const initialState: IState = {
    allCollectionsFetched: false, // TODO: Is this necessary to prevent more calls to server?
    error: undefined,
    isCreating: false,
    isCopying: false,
    isFetching: false,
    results: undefined,
};

export const collections = handleActions(
    {
        [COLLECTIONS.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [COLLECTIONS.FETCH.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetching: false,
                };
            }

            if (state.results && state.results.isSuperset(payload)) {
                return {
                    ...state,
                    allCollectionsFetched: true,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                results: state.results ? (state.results.concat(payload) as List<string>) : List(payload),
            };
        },
        [COLLECTIONS.CLEAR]: (): IState => {
            return {
                allCollectionsFetched: false,
                error: undefined,
                isFetching: false,
                results: undefined,
            };
        },
        [COLLECTIONS.COLLECTION.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isCreating: true,
            };
        },
        [COLLECTIONS.COLLECTION.CREATE.COMPLETED]: (state: IState, { error }: any): IState => {
            return {
                ...state,
                allCollectionsFetched: false,
                error,
                isCreating: false,
            };
        },
        [COLLECTIONS.COLLECTION.COPY.START]: (state: IState, { payload, error }: any): IState => {
            return {
                ...state,
                isCopying: true,
            };
        },
        [COLLECTIONS.COLLECTION.COPY.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            return {
                ...state,
                allCollectionsFetched: false,
                error,
                isCopying: false,
            };
        },
        [COLLECTIONS.COLLECTION.DELETE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return { ...state, error };
            }

            if (state.results === undefined) {
                return state;
            }

            const entityToBeRemoved = state.results.indexOf(payload);

            return {
                ...state,
                error,
                results: state.results.delete(entityToBeRemoved),
            };
        },
    },
    initialState
);
